import Service from "@/core/services/Service"

export default class TariffCoefficientService extends Service {
  constructor() {
    super()
    this.routerTariffCoefficient = "/api/lines/tariff-coefficient"
  }

  /**
   * Get all tariff coefficients
   */
  async searchTariffCoefficients(filters, order, page = 1) {
    let route = this.routerTariffCoefficient + "/search?page=" + page
    this.$Progress.start()

    let info = await this.request(route, "post", {
      filters: filters,
      orderBy: order,
    })
    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      return null
    }
  }

  /**
   * Get tariff coefficient by id
   * @param {int} id
   */
  async getTariffCoefficient(id) {
    let route = this.routerTariffCoefficient + "/" + id
    this.$Progress.start()

    let info = await this.request(route)

    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      return null
    }
  }

  /**
   * Create new tariff coefficient
   */
  async createTariffCoefficient(data) {
    this.$Progress.start()

    let info = await this.request(this.routerTariffCoefficient, "post", data)

    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      if (info.response.response.status == 422) {
        throw new Error(
          Object.entries(info.response.response.data.errors)[0][1][0]
        )
      } else {
        throw new Error(info.response.response.data.error)
      }
    }
  }

  /**
   * Update tariff coefficient
   */
  async updateTariffCoefficient(id, data) {
    this.$Progress.start()

    let info = await this.request(
      this.routerTariffCoefficient + "/" + id,
      "put",
      data
    )

    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      throw new Error("Erro ao atualizar linha")
    }
  }

  async getLastTariffCoefficient(nutransportadora) {
    let route = this.routerTariffCoefficient + "/search"
    this.$Progress.start()

    let filters = {
      nutransportadora: nutransportadora,
      limit: 1,
    }

    let order = {
      idcoeficientetarifa: "desc",
    }

    let info = await this.request(route, "post", {
      filters: filters,
      orderBy: order,
    })
    this.$Progress.finish()

    if (info.status === "success") {
      return info.response.data
    } else {
      return null
    }
  }
}
